import { defineComponent as _defineComponent } from 'vue'
import { Typo, Icon, Modal } from '@travelata-libs/ui-kit';
    import { useViewport } from '@travelata-libs/utils';
    import { ref } from 'vue';
    import HintTooltip from '@ve/components/hintTooltip/desktop/HintTooltip.vue';
    import { BONUS_MILES_TEXT, BONUS_MILES_INFO } from '../../lib/filterByBonusMiles';

    interface BonusMilesContentProps {
        tooltipType: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BonusMilesInfo',
  props: {
    tooltipType: { default: 'black' }
  },
  setup(__props: any) {

    

    const { isMobile } = useViewport();
    const isModalVisible = ref(false);

return { __sfc: true,isMobile, isModalVisible, Typo, Icon, Modal, HintTooltip, BONUS_MILES_TEXT, BONUS_MILES_INFO }
}

})